module.exports = __webpack_public_path__ + "img/TBANK.b617eb60.png";